import React, {startTransition, useState} from "react";
import {useQueryClient} from "react-query";
import {useNavigate, useParams} from "react-router-dom";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {useDepartmentList} from "../../hooks/useDepartmentList";
import {Controller, useForm} from "react-hook-form";
import SubTitle from "../../components/SubTitle";
import {FilterGroup, SubMenuGroup} from "../../styledComponents/StyledListContainer";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Pagination,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled,
} from "@mui/material";
import {locationValue} from "../../models/clientModels/data/selectList";
import {
  dangerEvaluationRevisionListActionButton,
  evaluationRevisionListActionButton,
} from "../../models/clientModels/data/actionButtonData";
import ActionButtonGroup from "../../components/ActionButtonGroup";
import {PaginationContainer} from "../../styledComponents/StyledPagination";
import MWSkeleton from "../../components/MWSkeleton";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {
  EvaluationListParams,
  WPDangerEvaluation,
  initializeEvaluationListParams,
} from "../../models/serverModels/permission/WPDangerEvaluation";
import {
  ResponseItem,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as dangerEvaluationApi from "../../api/permissionApi/dangerEvaluationApi";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {useGetQuery, useRemoveMutation} from "../../hooks/useQueryHooks";
import {alertStateAtom} from "../../Recoil/Atom/AlertAtom";
import {ReactComponent as WordIcon} from "../../assets/images/word.svg";
import {WPEvaluationMaster} from "../../models/serverModels/permission/WPEvaluationMaster";
import {StyledTableContainer, StyledTableHead} from "../../styledComponents/StyledTable";

const ListContainer = styled(Box)(({theme}) => ({
  minWidth: "1500px",
}));

const EvaluationRevisionList = () => {
  const {id} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const tokenState = useRecoilValue(tokenSelector);
  const setAlertState = useSetRecoilState(alertStateAtom);

  const {
    data: evaluationList,
    isLoading,
    isFetching,
  } = useGetQuery<ResponseItem<WPEvaluationMaster>>({
    key: ["GetRevisionMaster", id],
    api: () => dangerEvaluationApi.getRevisionMaster({token: tokenState, id: parseInt(id!)}),
  });

  const {mutate: removeMutate} = useRemoveMutation<ResponseRemove, Params.Remove>({
    api: dangerEvaluationApi.remove,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries("DangerEvaluationList");
      },
    },
  });

  return (
    <ListContainer>
      <SubTitle subTitle="작업위험성평가 개정 리스트" />
      <SubMenuGroup>
        {/* <FilterGroup>
          <Box>
            <Controller
              name="range"
              control={control}
              defaultValue={0}
              render={({field}) => (
                <FormControl>
                  <InputLabel id="range">범위</InputLabel>
                  <Select
                    style={{backgroundColor: "#fff"}}
                    {...field}
                    labelId="range"
                    id="range"
                    label="범위"
                    size="small"
                    onChange={selectChangeHandler}
                  >
                    {locationValue?.map((item) => (
                      <MenuItem
                        style={{backgroundColor: "#fff"}}
                        key={item.value}
                        value={item?.value!}
                      >
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          </Box>
          <Box>
            <Controller
              name="departmentUID"
              control={control}
              defaultValue={-1}
              render={({field}) => (
                <FormControl>
                  <InputLabel id="departmentUID">작성부서</InputLabel>
                  <Select
                    style={{backgroundColor: "#fff"}}
                    {...field}
                    labelId="departmentUID"
                    id="departmentUID"
                    label="작성부서"
                    size="small"
                    value={filter?.departmentUID}
                    onChange={selectChangeHandler}
                  >
                    <MenuItem value={-1}>전체</MenuItem>
                    {departmentList?.items.map((item) => (
                      <MenuItem style={{backgroundColor: "#fff"}} key={item.uid} value={item?.uid}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            />
          </Box>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box style={{backgroundColor: "#fff"}}>
              <DatePicker
                inputFormat={"yyyy년MM월dd일"}
                label="시작일"
                value={filter.startDate}
                onChange={startDateHandler}
                renderInput={(params) => (
                  <TextField size="small" sx={{fontSize: "10px"}} {...params} />
                )}
              />
            </Box>
            <Box style={{backgroundColor: "#fff"}}>
              <DatePicker
                inputFormat={"yyyy년MM월dd일"}
                label="종료일"
                value={filter.endDate}
                onChange={endDateHandler}
                renderInput={(params) => <TextField size="small" {...params} />}
              />
            </Box>
          </LocalizationProvider>
          <Box>
            <Controller
              name="contents"
              control={control}
              render={({field}) => (
                <TextField
                  style={{backgroundColor: "#fff"}}
                  {...field}
                  label="내용"
                  size="small"
                  onChange={FilteringHandler}
                />
              )}
            />
          </Box>

          <Button
            onClick={resetHandler}
            variant="contained"
            color="success"
            size="small"
            sx={{whiteSpace: "nowrap"}}
          >
            초기화
          </Button>
        </FilterGroup> */}
        <ActionButtonGroup data={evaluationRevisionListActionButton(id)} />
      </SubMenuGroup>
      <StyledTableContainer>
        <Table>
          <StyledTableHead>
            <TableRow>
              <TableCell align="center">#</TableCell>
              {/* <TableCell align="center">부서명</TableCell> */}
              {/* <TableCell align="center">일련번호</TableCell> */}
              {/* <TableCell align="center">내용</TableCell> */}
              <TableCell align="center">개정일</TableCell>
              <TableCell align="center">개정번호</TableCell>
              <TableCell align="center">개정사유</TableCell>
              <TableCell align="center">평가자</TableCell>
              <TableCell align="center">특이사항</TableCell>
              <TableCell align="center">편집</TableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {isLoading && isFetching ? (
              <MWSkeleton row={10} column={10} />
            ) : (
              evaluationList?.item?.revisions.map((item, index) => (
                <TableRow key={item.uid}>
                  <TableCell align="center">
                    {/* {page === 1
                      ? index + 1
                      : (page - 1) * initializeEvaluationListParams().rows! + index + 1} */}
                    {index + 1}
                  </TableCell>
                  {/* <TableCell align="center">
                    {departmentList?.items.map((value) =>
                      value.uid === item.departmentUID ? value.name : ""
                    )}
                  </TableCell> */}
                  {/* <TableCell align="center">{item.serialNo}</TableCell> */}
                  {/* <TableCell align="center">{item.contents}</TableCell> */}
                  <TableCell align="center">{`${new Date(item.revisionDate).getFullYear()}년 ${
                    new Date(item?.revisionDate).getMonth() + 1
                  }월 ${new Date(item?.revisionDate).getDate()}일`}</TableCell>
                  <TableCell align="center">{item.revisionNo}</TableCell>
                  <TableCell align="center">{item.reason}</TableCell>
                  <TableCell align="center">{item.evaluator}</TableCell>
                  <TableCell align="center">{item.isCompleted ? "검증완료" : ""}</TableCell>
                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      style={{marginRight: "12px"}}
                      onClick={() => {
                        navigate(`/Permission/Edit/${item.uid}`);
                      }}
                    >
                      편집
                    </Button>

                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={() => {
                        setAlertState({
                          toggle: true,
                          message: "등록된 리스트를 삭제하시겠습니까?",
                          execution: () => removeMutate({token: tokenState, id: item.uid}),
                        });
                      }}
                    >
                      삭제
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>

      {/* 페이지네이션 */}
      {/* <PaginationContainer>
        <Pagination
          count={1}
          page={page}
          onChange={paginationHandleChange}
          variant="outlined"
          color="primary"
          shape="rounded"
        />
      </PaginationContainer> */}
    </ListContainer>
  );
};

export default EvaluationRevisionList;
